import React, { PureComponent } from 'react'
import {
    TextField,
    Divider,
    Typography,
    // FormControlLabel,
    // Checkbox,
    Button,
} from '@material-ui/core'
import {
    riskMenuItems,
    amiMenuItems,
    fundingMenuItems,
    populationMenuItems,
    housingMenuItems,
    stewardingMenuItems,
} from 'shared/helpers';
import { Help } from '@material-ui/icons';
import { FlatButton, CustomTooltip } from 'shared/mui-styles';
import Dropdown from 'shared/components/Dropdown';
import DatePicker from 'bundles/Dashboard/components/DatePicker';

const classes = {
    fullWidth: {
        width: '100%',
    },
    halfWidth: {
        width: '35%'
    },
    divider: {
        margin: '15px 0',
    },
    h7: {
        fontSize: '1.10rem',
        fontWeight: '400',
    },
}

class ExistingFilter extends PureComponent {
    render() {
        const { 
           
            risk,
            ami,
            funding,
            population,
            housing,
            stewarding,
            minSubUnits,
            maxSubUnits,
            minPerUnitSub,
            maxPerUnitSub,
            subStartDateBegin,
            subStartDateEnd,
            subEndDateBegin,
            subEndDateEnd,
        
            handleChange,
            makeDateHandler, 
            onSubmit,
            onReset,

        } = this.props;

        const data = [
            {
                value: risk,
                name: 'risk',
                menuItems: riskMenuItems,
            },
            {
                value: ami,
                name: 'ami',
                menuItems: amiMenuItems,
            },
            {
                value: funding,
                name: 'funding',
                menuItems: fundingMenuItems,
            },
            {
                value: population,
                name: 'population',
                menuItems: populationMenuItems,
            },
            {
                value: housing,
                name: 'housing',
                menuItems: housingMenuItems,
            },
            {
                value: stewarding,
                name: 'stewarding',
                menuItems: stewardingMenuItems,
            },
        ]
        
        return (
            <div className="filter-container">
                <div className="content">
                    <div className="container-fluid card-with-padding">
                        {/* <div className="row row-spacing">
                            <div className="col">
                                <Typography variant="h6" style={classes.h7}>
                                    Property Lookup
                                </Typography>
                                <TextField
                                    id="outlined-dense"
                                    placeholder="Address or property name"
                                    style={classes.fullWidth}
                                    margin="dense"
                                    variant="outlined"
                                />
                            </div>
                        </div> */}
                        <div className="row row-spacing">
                            <div className="col">
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                    <Typography variant="h6" style={classes.h7}>
                                        At-Risk Units
                                    </Typography>
                                    <CustomTooltip
                                        title="Properties with subsidies expiring within the timeframe selected (6 months, 1 year, 3 years, or 5 years)"
                                        placement="right"
                                    >
                                        <Help fontSize="small" style={{ marginLeft: 7 }} color="secondary" />
                                    </CustomTooltip>
                                </div>
                                <Dropdown
                                    data={data[0]}
                                    handleChange={handleChange}
                                />
                            </div>
                        </div>
                        <Divider style={classes.divider} />
                        <div className="row row-spacing">
                            <div className="col">
                                <Typography variant="h6" style={classes.h7}>
                                    Total Subsidized Units in Building
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center'}}>
                                    <Typography variant="body2" style={{ marginRight: '8px'}}>
                                        Between
                                    </Typography>
                                    <TextField
                                        id="minSubUnits"
                                        placeholder="Min count"
                                        style={classes.halfWidth}
                                        value={minSubUnits}
                                        onChange={handleChange}
                                        margin="dense"
                                        type="number"
                                        variant="outlined"
                                    />
                                    <Typography variant="body2" style={{ margin: '0 8px' }}>
                                        and
                                    </Typography>
                                    <TextField
                                        id="maxSubUnits"
                                        placeholder="Max count"
                                        style={classes.halfWidth}
                                        value={maxSubUnits}
                                        onChange={handleChange}
                                        margin="dense"
                                        type="number"
                                        variant="outlined"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row row-spacing">
                            <div className="col">
                                <Typography variant="h6" style={classes.h7}>
                                    Percent Units Subsidized
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography variant="body2" style={{ marginRight: '8px' }}>
                                        Between
                                    </Typography>
                                    <TextField
                                        id="minPerUnitSub"
                                        placeholder="Min %"
                                        style={classes.halfWidth}
                                        value={minPerUnitSub}
                                        onChange={handleChange}
                                        margin="dense"
                                        type="number"
                                        variant="outlined"
                                    />
                                    <Typography variant="body2" style={{ margin: '0 8px' }}>
                                        and
                                    </Typography>
                                    <TextField
                                        id="maxPerUnitSub"
                                        placeholder="Max %"
                                        style={classes.halfWidth}
                                        value={maxPerUnitSub}
                                        onChange={handleChange}
                                        margin="dense"
                                        type="number"
                                        variant="outlined"
                                    />
                                </div>
                            </div>
                        </div>
                        <Divider style={classes.divider} />
                        <div className="row row-spacing">
                            <div className="col">
                                <Typography variant="h6" style={classes.h7}>
                                    Unit AMI
                                </Typography>
                                <Dropdown
                                    data={data[1]}
                                    handleChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="row row-spacing">
                            <div className="col">
                                <Typography variant="h6" style={classes.h7}>
                                    Funding Source
                                </Typography>
                                <Dropdown
                                    data={data[2]}
                                    handleChange={handleChange}
                                />
                            </div>
                        </div>
                        <Divider style={classes.divider} />
                        <div className="row row-spacing">
                            <div className="col">
                                <Typography variant="h6" style={classes.h7}>
                                    Target Population
                                </Typography>
                                <Dropdown
                                    data={data[3]}
                                    handleChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="row row-spacing">
                            <div className="col">
                                <Typography variant="h6" style={classes.h7}>
                                    Development Type
                                </Typography>
                                <Dropdown
                                    data={data[4]}
                                    handleChange={handleChange}
                                />
                            </div>
                        </div>
                        <Divider style={classes.divider} />
                        <div className="row row-spacing">
                            <div className="col">
                                <Typography variant="h6" style={classes.h7}>
                                    Subsidy Start Date
                                </Typography>
                                <DatePicker
                                    makeDateHandler={makeDateHandler}
                                    pickerData={[
                                        {
                                            key: 'subStartDateBegin',
                                            stateVariable: subStartDateBegin
                                        },
                                        {
                                            key: 'subStartDateEnd',
                                            stateVariable: subStartDateEnd
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="row row-spacing">
                            <div className="col">
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <Typography variant="h6" style={classes.h7}>
                                        Subsidy End Date
                                    </Typography>
                                    <CustomTooltip
                                        title={!!risk
                                            ? 'This option is not available as the At-Risk Units filter already fills subsidy end dates. Please unselect At-Risk Units if you want to use a specific End Date.'
                                            : `To display properties with expired subsidies, select today's date as the End Date of this filter.`}
                                        placement="right"
                                    >
                                        <Help fontSize="small" style={{ marginLeft: 7 }} color="secondary" />
                                    </CustomTooltip>
                                </div>
                                <DatePicker
                                    makeDateHandler={makeDateHandler}
                                    disabled={!!risk}
                                    pickerData={[
                                        {
                                            key: 'subEndDateBegin',
                                            stateVariable: subEndDateBegin
                                        },
                                        {
                                            key: 'subEndDateEnd',
                                            stateVariable: subEndDateEnd
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                        <Divider style={classes.divider} />
                        <div className="row row-spacing">
                            <div className="col">
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <Typography variant="h6" style={classes.h7}>
                                        Stewarding Agency
                                    </Typography>
                                    <CustomTooltip
                                        title="A stewarding agency administers an affordable housing subsidy at a certain property"
                                        placement="right"
                                    >
                                        <Help fontSize="small" style={{ marginLeft: 7 }} color="secondary" />
                                    </CustomTooltip>
                                </div>
                                <Dropdown
                                    data={data[5]}
                                    handleChange={handleChange}
                                />
                            </div>
                        </div>
                        {/* <div className="row row-spacing">
                            <div className="col">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={expiredUnits}
                                            onChange={this.makeCheckBoxHandler('expiredUnits')}
                                            value="expiredUnits"
                                            color="primary"
                                        />
                                    }
                                    label="Include Expired Units"
                                    labelPlacement="start"
                                />
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="bottom-bar">
                    <FlatButton
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={onSubmit}
                    >
                        {/* {`Update ${mapOrTable ? 'Table' : 'Map'}`} */}
                        APPLY FILTERS
                    </FlatButton>
                    <Button
                        variant="outlined"
                        style={{ width: '100%', marginTop: 10 }}
                        onClick={onReset}
                    >
                        Clear Filters
                    </Button>
                </div>
            </div>
        )
    }
    
}

export default ExistingFilter